import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../../ui/portal";
import PortalAppBar from "../../ui/portalAppBar";
import PortalGridContent from "../../ui/portalGridContent";
import EmpireEmployees from "../../widgets/empireOS/empireEmployees";
import EmpireInformation from "../../widgets/empireOS/empireInformation";
import EmpireKPI from "../../widgets/empireOS/empireKPI";
import EmpireStoplight from "../../widgets/empireOS/empireStoplight";
import EmpireTodo from "../../widgets/empireOS/empireTodo";

const EmpirePartnerPortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Empire OS" />
      <PortalGridContent>
        <Grid item sm={12} md={4}>
          <EmpireTodo />
        </Grid>
        <Grid item sm={12} md={8}>
          <EmpireEmployees />
        </Grid>
        <Grid item sm={12} md={6}>
          <EmpireInformation />
        </Grid>
        <Grid item sm={12} md={6}>
          <EmpireKPI />
        </Grid>
        <Grid item sm={12} md={8}>
          <EmpireStoplight />
        </Grid>

        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(EmpirePartnerPortal);
